import {Baecha} from "./Baecha";
import {CallPass} from "./CallPass";
import {BaechaWorkDay} from "./BaechaWorkDay";
import {BaechaUpdateHistory} from "./BaechaUpdateHistory";

export interface SelectedDataIF {
	baechaData: Baecha | undefined;
	callPassData: CallPass[];
	baechaWorkDayData: BaechaWorkDay[];
	baechaUpdateHistoryData: BaechaUpdateHistory[];
}

export const emptySelectedData: SelectedDataIF = {
	baechaData: undefined,
	callPassData: [],
	baechaWorkDayData: [],
	baechaUpdateHistoryData: [],
}
